<template>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ExportWithdrawalsToExcel',
  methods: {
    ...mapActions(['exportWithdrawalsToExcel']),
    actionExportWithdrawalsToExcel (date) {
      this.exportWithdrawalsToExcel({ date })
    }
  }
}
</script>